import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8h5z"
}), 'HomeSharp');